import {
  Typography,
  Space,
  Input,
  Form,
  Row,
  Col,
  Divider,
  Flex,
  Image,
  Button,
} from "antd";
import { ActionButton, CitiesInput, CitiesSelect } from "../../";
import { LLFormatWithTime } from "../../../shared";
import "./index.css";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

const SessionPrescription = ({
  state,
  form,
  medicinesLookup,
  handleChange,
  handleAddCustomMedicine,
  handleRemoveMedicine,
}) => {
  return (
    <>
      <Form
        layout="vertical"
        form={form}
        initialValues={{ remember: true }}
        className="prescribed-medicines-form"
      >
        <Row gutter={16}>
          <Col span={24} md={12}>
            <CitiesSelect
              mode="multiple"
              name="medicines"
              label="Medicines"
              required
              message="please select at least one medicine"
              placeholder="e.g Cap Cefspan 400 mg"
              onChange={(value, options) => {
                handleChange("medicines", options);
              }}
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              options={medicinesLookup}
            />
          </Col>
        </Row>
        <div className="justify-center w-100">
          <div className="prescribed-medicines-page width-100">
            <header></header>
            <div>
              <Space className="width-100" direction="vertical" size={16}>
                <div className="space-between client-info width-100">
                  <div className="space-d" style={{ width: "300px" }}>
                    <Text>Name</Text>
                    <Input size="small" value={state?.name} readOnly />
                  </div>
                  <div className="space-d" style={{ width: "100px" }}>
                    <Text>Age</Text>
                    <Input size="small" value={state?.age} readOnly />
                  </div>
                  <div className="space-d" style={{ width: "270px" }}>
                    <Text>Date</Text>
                    <Input size="small" value={LLFormatWithTime()} readOnly />
                  </div>
                </div>
                {state?.medicines?.map((medicine, index) => (
                  <div
                    key={medicine.id || `custom-${index}`}
                    className="medicine-item"
                  >
                    {medicine?.isCustom && (
                      <Flex justify="end">
                        <ActionButton
                          onClick={() => handleRemoveMedicine(medicine.id)}
                          danger
                          icon={<DeleteOutlined />}
                        />
                      </Flex>
                    )}
                    <Row gutter={[12, 12]} style={{ marginTop: 12 }}>
                      <Col span={24} md={12}>
                        <CitiesInput
                          isControlled
                          label="Medicine Name"
                          placeholder="Enter medicine name"
                          required
                          message={"Please enter medicine name"}
                          value={medicine?.medicineName}
                          onChange={(e) =>
                            handleChange("medicineName", e.target.value, index)
                          }
                        />
                      </Col>
                      <Col span={24} sm={12}>
                        <CitiesInput
                          isControlled
                          label="Intake Instructions"
                          placeholder="Enter notes"
                          required
                          message={"Please enter notes"}
                          value={medicine?.notes}
                          onChange={(e) =>
                            handleChange("notes", e.target.value, index)
                          }
                        />
                      </Col>
                    </Row>
                    {index < state?.medicines?.length - 1 && (
                      <Flex justify="center" className="my-1">
                        <img
                          src="/assets/icons/hr-el.webp"
                          width={35}
                          alt="hr-dots"
                        />
                      </Flex>
                    )}
                  </div>
                ))}
                <Button
                  type="dashed"
                  onClick={handleAddCustomMedicine}
                  style={{ width: "100%" }}
                >
                  + Add Medicine
                </Button>
              </Space>
            </div>
            <footer></footer>
          </div>
        </div>
      </Form>
    </>
  );
};

export { SessionPrescription };
